'use client';

import React from 'react';
import { Menu, Search, RefreshCw } from 'lucide-react';

interface HeaderProps {
  activeTab: 'OVERVIEW' | 'KYC' | 'WORKSPACES' | 'USERS' | 'AUDIT_LOG';
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  setMobileMenuOpen: (open: boolean) => void;
  onRefresh: () => void;
  loading: boolean;
}

export const Header: React.FC<HeaderProps> = ({
  activeTab,
  searchTerm,
  setSearchTerm,
  setMobileMenuOpen,
  onRefresh,
  loading,
}) => {
  return (
    <header className="h-16 bg-[#0A0D1A]/90 backdrop-blur-xl border-b border-slate-800/80 px-6 flex items-center justify-between shrink-0">
      <div className="flex items-center gap-4">
        <button
          onClick={() => setMobileMenuOpen(true)}
          className="lg:hidden text-slate-400 hover:text-white p-1 cursor-pointer"
        >
          <Menu className="w-5 h-5" />
        </button>

        <div className="flex items-center gap-3">
          <h1 className="text-base font-extrabold text-white tracking-tight">
            {activeTab === 'OVERVIEW' && 'Platform Overview'}
            {activeTab === 'KYC' && 'KYC Application Requests'}
            {activeTab === 'WORKSPACES' && 'Workspaces Management'}
            {activeTab === 'USERS' && 'User Directory'}
            {activeTab === 'AUDIT_LOG' && 'Audit Logs'}
          </h1>
          <span className="px-2.5 py-0.5 rounded-full bg-indigo-500/10 border border-indigo-500/20 text-indigo-400 text-[10px] font-mono font-bold uppercase tracking-wider">
            {activeTab}
          </span>
        </div>
      </div>

      <div className="flex items-center gap-4">
        {(activeTab === 'WORKSPACES' || activeTab === 'USERS') && (
          <div className="relative hidden sm:block w-64">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-slate-500">
              <Search className="w-3.5 h-3.5" />
            </div>
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder={`Search ${activeTab.toLowerCase()}...`}
              className="w-full bg-[#060811] border border-slate-800 rounded-xl pl-9 pr-3 py-1.5 text-xs text-slate-100 placeholder-slate-500 focus:outline-none focus:border-indigo-500 transition-colors"
            />
          </div>
        )}

        <button
          onClick={onRefresh}
          disabled={loading}
          className="p-2 rounded-xl bg-slate-900 border border-slate-800 text-slate-400 hover:text-white hover:bg-slate-800 transition-all cursor-pointer disabled:opacity-50"
          title="Refresh Data"
        >
          <RefreshCw className={`w-4 h-4 ${loading ? 'animate-spin text-indigo-400' : ''}`} />
        </button>
      </div>
    </header>
  );
};
